import { TableHead, TableRow } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const CellHeaderStyled = styled(TableHead)({
  backgroundColor: '#0A1123',
  '& th': {
    color: '#FFF',
    fontWeight: 500,
    border: 'none',
  },
});

export const CellStyled = styled(TableRow)({
  backgroundColor: alpha('#192033', 0.9),
  color: '#999',
  border: 'none',
  '&:nth-of-type(odd)': {
    backgroundColor: '#171D2D',
    color: 'lightgray',
  },
  '& td': {
    color: 'lightgray',
    border: 'none',
  },
  '& .date': {
    color: '#FF8B9A',
  },
});
